<template>
    <div class="lang-switch" v-if="type === 'inline'">
        <a class="u-reset lang-switch--inline-item"
                v-for="(lang, idx) in languages"
                :key="idx"
                :class="getItemClass(lang.label)"
                :href="lang.path">
            {{ lang.label }}
        </a>
    </div>

    <div class="lang-switch" v-else>
        <div class="lang-switch--backdrop" v-if="isOverlayOpen" @click="toggleOverlay"/>
        <button class="lang-switch--toggle" @click="toggleOverlay">
            {{ currentLang }}
            <base-icon
                    class="lang-switch--chevron"
                    symbol="chevron-down"
                    size="small"
                    slot="indicator"
                    :class="chevronClass"
            />
        </button>
        <div class="lang-switch--overlay" v-if="isOverlayOpen">
            <a class="u-reset lang-switch--item"
                    v-for="(lang, idx) in languages"
                    :key="idx"
                    :class="getItemClass(lang.label)"
                    :href="lang.path">
                {{ lang.label }}
            </a>
        </div>
    </div>

</template>

<script>

    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('lang-switch')],

        props: {

            /** @type {ILink[]} */
            languages: {
                type: Array,
                required: true,
            },

            type: {
                type: String,
                default: () => 'hover',
            },
        },

        data() {
            return {
                currentLang: null,
                isOverlayOpen: false,
            };
        },

        computed: {
            chevronClass() {
                if (this.isOverlayOpen) {
                    return this.bemAdd('active', 'chevron');
                }
                return null;
            },
        },


        methods: {
            toggleOverlay() {
                this.isOverlayOpen = !this.isOverlayOpen;
            },

            getItemClass(lang) {
                return [
                    this.bemAdd(this.currentLang === lang ? 'active' : null, 'inline-item'),
                ];
            },
        },

        mounted() {
            this.currentLang = document.documentElement.lang;
        },
    };
</script>
